



















import {Component, Vue} from 'vue-property-decorator';
import {EAD_DTO} from "@/dto/person/EAD_DTO";
import {namespace} from "vuex-class";
import PersonService from "@/services/PersonService";
import {PERSON_ID} from "@/constants/Paths";
import PortalCollapse from "@/components/request/w9cr/PortalCollapse.vue";
import AddEADPayload from "@/dto/person/AddEADPayload";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import {PersonSex} from "@/constants/PersonConstants";
import Workspaces from "@/state/Workspaces";
import {ifValid, processError} from "@/utils/ComponentUtils";
import EAD from "@/components/profile/person/EAD.vue";
import AddForeignIDPayload from "@/dto/person/AddForeignIDPayload";
import ForeignID_DTO from "@/dto/person/ForeignID_DTO";

const AppModule = namespace("App");


@Component({
  computed: {
    PersonSex() {
      return PersonSex
    }
  },
  components: {EAD, PortalDate, PortalInput, SingleFileHolder, PortalCollapse}
})
export default class EADList extends Vue {

  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  addMode = false;

  documents: Array<ForeignID_DTO> = [];

  payload = new AddForeignIDPayload();

  mounted(){
    this.loadDocuments();
  }

  loadDocuments(){
    this.startLoading();
    PersonService.getForeignId(this.personId).then(
        ok => {
          this.documents = ok.data;
          this.stopLoading();
        },
        error => {
          this.stopLoading();
          processError(this, error);
        }
    )
  }

  get personId(){
    return Workspaces.getCurrent.id;
  }

  addDocument(){
    ifValid(this, () => {
      this.startLoading();
      PersonService.addForeignID(this.personId, this.payload).then(
          ok => {
            this.payload = new AddForeignIDPayload();
            this.addMode = false;
            this.stopLoading();
            this.loadDocuments();
          },
          error => {
            processError(this, error);
            this.stopLoading();
          }
      )
    })
  }

}
